window.SpaceStation = window.SpaceStation || {};
window.SpaceStation.CommandModule = window.SpaceStation.CommandModule || {};
window.SpaceStation.CommandModule.Slider = window.SpaceStation.CommandModule.Slider || {};

window.SpaceStation.CommandModule.Slider.Tab = (function($, Behaviors, module) {
    class Tab extends Behaviors.Behavior {
        static QUERY = "[data-sscmslider-tab]"

        static PARENT_QUERY = "[data-sscmslider]";
        static SLIDER_QUERY = "[data-sscmslider-contentrow]";

        constructor(...args) {
            super(...args)

            this.parent = this.elem.closest(Tab.PARENT_QUERY);
            this.slider = this.parent.querySelector(Tab.SLIDER_QUERY);
            this.tabs = module.Tabs.locate(this.elem.closest(module.Tabs.QUERY));

            this.$slider = $(this.slider);

            this.target = parseInt(this.elem.dataset.sscmsliderTab);
            this.currentSlide = 0;

            this.elem.addEventListener("touchend", this.click_intent.bind(this));
            this.elem.addEventListener("click", this.click_intent.bind(this));
            this.$slider.on("afterChange", this.slide_change_intent.bind(this));

            this.slide_change_intent(null, this.$slider.slick("getSlick"), this.$slider.slick("slickCurrentSlide"));
        }

        click_intent(e) {
            e.preventDefault();
            e.stopPropagation();
            
            this.tabs.expand_contract_intent();
            this.$slider.slick("slickGoTo", this.target);

            //Tell our tab container that we're about to change the slide.
            //It also listens to afterChange, but that's visibly too late, and
            //for some reason beforeChange is very bugged
            this.tabs.slide_change_intent(null, null, this.target);
        }

        slide_change_intent(event, slick, currentSlide) {
            this.currentSlide = currentSlide;
            this.elem.classList.toggle("is-SSCMSlider-tab--active", currentSlide === this.target);
        }
    }

    Behaviors.register_behavior(Tab);

    return Tab;
}(window.jQuery, window.EVASuit.Behaviors, window.SpaceStation.CommandModule.Slider))